<mega-page-title [title]="content?.title"></mega-page-title>

<div [innerHTML]="content?.content | EscapeHtml" routeTransform></div>

<mega-social-media></mega-social-media>